import React, { useContext } from 'react'
import { Link } from 'gatsby'
import UserContext from '@context/UserContext'
import imgWelcome from '@images/UserAccount/welcome-back.webp'
import imgWelcomeNew from '@images/UserAccount/welcome-newreg.webp'
import bbLogoWhite from '@images/logos/bb-logo-text-white.svg'

const WelcomeBack = ({handleClose}) => {
	const { newlyRegistered } = useContext(UserContext)

	return (
    <React.Fragment>
      <section className="w-full">
        <div className='relative'>
					<img
						src={ newlyRegistered ? 
                imgWelcomeNew 
                : imgWelcome }
						alt="welcome back"
					/>
					<img className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32' src={bbLogoWhite} alt='Blackbough Swim' />
				</div>

        <div className="py-7 px-12 text-center mx-auto">
          <p className="text-[24px] font-semibold">
            Welcome {newlyRegistered ? "to Blackbough" : "back"}, babe! 🎉
          </p>
          <p className="text-[#5D5D5D] text-md">
            {newlyRegistered
              ? `You're all set! Now you're ready to shop our latest styles.`
              : `Time to pick up where you left off and shop your favorites.`}
          </p>

          <div className="pt-6 flex md:inline-flex justify-center gap-4 flex-wrap-reverse">
						<button
              className={`${newlyRegistered ? 'btn-primary w-28' : 'btn-outline w-[208px]'}`}
              onClick={handleClose}
              aria-label={newlyRegistered ? 'Shop Now' : 'Continue Shopping'}
            >
              {newlyRegistered ? 'Shop Now' : 'Continue Shopping'}
            </button>
						{!newlyRegistered && (
							<Link
								className="btn-primary w-[208px] flex items-center justify-center"
								onClick={handleClose}
								to="/user-account/personal-information"
								aria-label="Go to my account"
							>
								Go to my account
							</Link>
						)}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}

export default WelcomeBack